export default "__VITE_ASSET__Bd1wV02___"